import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import axios from "../helper/axios";
import { useSelector } from "react-redux";

export default function AddProduct(props) {
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const [chooseFile, setChooseFile] = useState([]);


  const uploadImages = async () => {
    const formData = new FormData();
    Object.values(chooseFile).forEach(file => {
      console.log(file)
      formData.append("multiFile", file);
    });
    formData.append("vendorEmail", auth?.user?.email)
    const res = await axios.post("/multiimage", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    if (res.status === 200) {
      alert("Image Uploaded Successfully");
      props.apiData();
    }
  }

  return (
    <div className="box-body col-md-3">
      <div className="input-group">
        <input type="file"
          className="form-control"
          multiple
          name="multiFile"
          // onChange={onSelectFile}
          onChange={(e) => setChooseFile(e.target.files)} />
        <span className="input-group-btn">
          <button className="btn btn-primary btn-flat" onClick={(e) => uploadImages()}>Upload Images</button>
        </span>
      </div>
    </div>
  )
}